export const HSA_FSA_TEST_COOKIE = "hsa_fsa_test";
export const HSA_FSA_TEST_VARIANT = "variant";
export const HSA_FSA_EXPERIMENT_VIEWED_COOKIE = "hsa_fsa_experiment_viewed";
export const HSA_FSA_EXPERIMENT_ID = "35";
export const HSA_FSA_EXPERIMENT_NAME = "Payment Q326 | HSA/FSA TrueMed";
export const HSA_FSA_CART_PATH = "/checkout/cart";

// Main core PDPs where the HSA/FSA test lives — matches the badge gate in TruemedWidget.tsx.
export const HSA_FSA_ELIGIBLE_PDPS = [
  "/hair/women/product/core/women-advanced",
  "/hair/women/product/core/balance",
  "/hair/women/product/core/postpartum",
  "/hair/men/product/core/men",
  "/hair/men/product/core/men50",
];

/*
 * Duo booster PDPs where the HSA/FSA widget shows for eligible products — matches the
 * badge gate in TruemedWidget.tsx. Same AB test cookie gate as HSA_FSA_ELIGIBLE_PDPS applies.
 */
export const HSA_FSA_ELIGIBLE_DUO_PDPS = [
  "/hair/women/product/booster/hair-growth-resilience-duo",
  "/hair/women/product/booster/hair-growth-synbiosis-duo",
  "/hair/women/product/booster/hair-growth-strength-duo",
  "/hair/women/product/booster/hair-growth-equilibrium-duo",
  "/hair/women/product/booster/hair-growth-shield-duo",
  "/hair/women/product/booster/hair-growth-longevity-duo",
  "/hair/men/product/booster/hair-growth-resilience-duo",
  "/hair/men/product/booster/hair-growth-synbiosis-duo",
  "/hair/men/product/booster/hair-growth-strength-duo",
  "/hair/men/product/booster/hair-growth-shield-duo",
  "/hair/men/product/booster/hair-growth-longevity-duo",
  "/hair/men/product/booster/hair-growth-defense-duo",
];
